import Gallery from "../../components/AboutUs/Gallery";
import Hero from "../../components/AboutUs/Hero";
import NewsArticles from "../../components/AboutUs/NewsArticles";
import Stats from "../../components/AboutUs/Stats";
import Teams from "../../components/AboutUs/Teams";
import Seo from "../../components/SEO/Seo";
import AboutLayout from "./AboutLayout";
function AboutUs() {
  return (
    <AboutLayout>
      <Seo
        title="Bataiyo | About Us"
        description="Learn more about Bataiyo, our vision, mission, and the people behind our journey to innovate and create impact."
        keywords="Bataiyo, About Bataiyo, Our Mission, Our Vision, Team Bataiyo, About Us Page, Company Story, Who We Are"
        url="about-us"
      />
      <Hero />
      <Teams />
      <Stats />
      <Gallery />
      <NewsArticles />
    </AboutLayout>
  );
}

export default AboutUs;
